export default __webpack_public_path__ + "static/media/consultation.dc77a349.svg";